import { Paper, Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/DateTimePicker/components/OptionsDropdown/OptionsDropdown.styles';
import { NOW, useDates } from 'context/DateProvider/DateProvider';
import { CUSTOM_OPTION } from 'utils/dateTimePickerOptions';

type OptionsDropdownProps = {
  options: Map<string, string>;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  setShowOptions: React.Dispatch<React.SetStateAction<boolean>>;
  setShowCustomPicker: React.Dispatch<React.SetStateAction<boolean>>;
};

const OptionsDropdown = ({
  options,
  setSelectedOption,
  setShowOptions,
  setShowCustomPicker,
}: OptionsDropdownProps) => {
  const classes = useStyles();
  const { dates, setDates } = useDates();

  const handleChangeSelector = (value: any) => {
    setSelectedOption(value);

    if (value === CUSTOM_OPTION) {
      setShowCustomPicker(true);
      setShowOptions(false);
      return;
    } else {
      setShowCustomPicker(false);

      const hoursToRemove = options.get(value);

      setDates({
        ...dates,
        from: `${NOW}-${hoursToRemove}h`,
        to: NOW,
      });
      setShowOptions(false);
    }
  };

  return (
    <Paper elevation={4} className={classes.popupBox}>
      {Array.from(options.keys()).map((key) => (
        <Typography
          key={key}
          className={classes.popupText}
          onClick={() => handleChangeSelector(key)}
        >
          {key}
        </Typography>
      ))}
    </Paper>
  );
};

export default OptionsDropdown;
